'use client';

import { gridLayout } from "../../styles/mixins/grid.mjs";
import styled from "../../../core/styled-components.mjs";
export var GridLayout = styled.div.withConfig({
  displayName: "GridLayout",
  componentId: "sc-gphf5r-0"
})(["", ";"], gridLayout);
export var gridLayoutMixin = gridLayout;